import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';
import Loading from '../../../func/components/loading/LoadingCircle';

interface NoticeItem {
  name: null;
  title: string;
  branch: null;
  deletebtn: string;
  writetime: string;
  articleidx: number;
  commentcount: number;
}

interface Props {
  noticeList: NoticeItem[];
  isLoading: boolean;
}

function Notice({ noticeList, isLoading }: Props) {
  const navigate = useNavigate();
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0];

  return (
    <Container>
      <SectionTitle>
        공지사항
        <ViewMoreButton onClick={() => navigate('/board')}>
          전체보기
          <img src="/assets/images/arrow/arrow-right-gray-small.svg" alt="" />
        </ViewMoreButton>
      </SectionTitle>

      {!isLoading &&
        (noticeList.length > 0 ? (
          <Content>
            {noticeList.map((item) => (
              <Item
                key={item.articleidx}
                onClick={() => navigate(`board/detail/${item.articleidx}`)}
              >
                <ListTitle>
                  <TitleBox>
                    <ListDot>•</ListDot>
                    <Title>{item.title}</Title>
                  </TitleBox>
                  {item.writetime.split('T')[0] === formattedDate && (
                    <img
                      src="/assets/images/icon/new.svg"
                      alt=""
                      width={16}
                      height={16}
                    />
                  )}
                </ListTitle>
                <DateText>{item.writetime.split('T')[0]}</DateText>
              </Item>
            ))}
          </Content>
        ) : (
          <Content>
            <Title>공지사항이 없습니다.</Title>
          </Content>
        ))}
    </Container>
  );
}

export default Notice;

const Container = styled.div`
  width: 100%;
  display: flex;
  padding: 32px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  background: #fff;
`;

const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  color: rgba(0, 12, 30, 0.8);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const ViewMoreButton = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  color: #4e5968;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const Item = styled.div`
  width: 100%;
  display: flex;
  padding: 4px 0px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const ListTitle = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const TitleBox = styled.div`
  /* flex: 1; */
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
`;

const ListDot = styled.span`
  width: 16px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
`;

const Title = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 16px;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const DateText = styled.div`
  color: var(--semantic-label-alternative, rgba(55, 56, 60, 0.61));
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;
